"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeStampArrowIcon = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("@emotion/react");
const TimeStampArrowIcon = (_a) => {
    var { color, style } = _a, props = __rest(_a, ["color", "style"]);
    const theme = (0, react_1.useTheme)();
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ width: "16", height: "14", viewBox: "0 0 16 14", fill: "none" }, props, { children: (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.51789 1.23864L14.7588 6.42386C15.0804 6.74206 15.0804 7.25794 14.7588 7.57614L9.51789 12.7614C9.19628 13.0795 8.67485 13.0795 8.35324 12.7614C8.03163 12.4432 8.03163 11.9273 8.35324 11.6091L12.1883 7.81478H1V6.18522H12.1883L8.35324 2.39091C8.03163 2.07272 8.03163 1.55683 8.35324 1.23864C8.67485 0.920452 9.19628 0.920452 9.51789 1.23864Z", fill: color !== null && color !== void 0 ? color : theme.colors.white }) })));
};
exports.TimeStampArrowIcon = TimeStampArrowIcon;
//# sourceMappingURL=time_stamp_arrow_icon.js.map